import { v4 } from "uuid";
// import {ModosOp, TipoDeCliente, TipoDeDoc} from './Constantes'
// import {CargarErrorComunicEnClienteAFacturar} from "./AccionesTypeFact";
// import * as Action from './Actions'
// import {estadoCargado} from '..reductores/EstadosDialogoClienteAFacturar'
// import Estado from "./EstadoDialogoClienteAFacturar";
// import AccionSet from './ActionSet'
import ActionTypeItem from "./acciones/ActionTypeItem";
// import React from "react";
// import { Error } from "../../comun/Eventos";

/**
 * @param {object} state Estado
 * @param {object} action Accion
 * @returns {void} Retorna un nuevo estado
 */
export default function ItemReducer(state, action) {
    const estadoTemp = { ...state, domain: { ...state.domain } };
    estadoTemp.domain.cargado = {};
    const nuevoEstado = JSON.parse(JSON.stringify(estadoTemp));
    nuevoEstado.domain.cargado = state.domain.cargado;

    switch (true) {
        // case action instanceof AccionesFact.SetCodigoCliente:
        case action instanceof ActionTypeItem:
            return action.ejecutar(state, nuevoEstado);
            
        default:
            break;
    }
}
